/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonNotification,
    JsonNotificationFromJSON,
    JsonNotificationFromJSONTyped,
    JsonNotificationToJSON,
} from './JsonNotification';

/**
 * 
 * @export
 * @interface ApiResultOfJsonNotification
 */
export interface ApiResultOfJsonNotification {
    /**
     * 
     * @type {JsonNotification}
     * @memberof ApiResultOfJsonNotification
     */
    data?: JsonNotification;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonNotification
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonNotification
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonNotification
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonNotification
     */
    result?: ApiResultOfJsonNotificationResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonNotificationResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonNotificationFromJSON(json: any): ApiResultOfJsonNotification {
    return ApiResultOfJsonNotificationFromJSONTyped(json, false);
}

export function ApiResultOfJsonNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonNotificationFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonNotificationToJSON(value?: ApiResultOfJsonNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonNotificationToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

